import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { first } from 'rxjs/operators';

import { isUndefined, mergeRouteParams } from 'app/helpers';
import { PosRoleEnum } from 'app/interfaces';
import { PointOfSaleService } from 'app/services';

export const posProfileRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const pointOfSaleService = inject(PointOfSaleService);
    const params = mergeRouteParams(route);
    if (!params.posId) {
        router.navigate(['/']);
        return false;
    }

    const canAccess: ReplaySubject<boolean> = new ReplaySubject(1);

    if (route.data && route.data['allowedRoles'] && route.data['allowedRoles'].indexOf(PosRoleEnum.Guest) === -1) {
        pointOfSaleService
            .getPointOfSaleRole(params.posId)
            .pipe(first())
            .subscribe({
                next: (meRole) => {
                    if (
                        route.data &&
                        route.data['allowedRoles'] &&
                        !isUndefined(meRole) &&
                        route.data['allowedRoles'].indexOf(meRole) !== -1
                    ) {
                        pointOfSaleService.setIsAdminProfile(!!route.data['adminProfile']);
                        canAccess.next(true);
                        return;
                    }

                    router.navigate(['/pos', params.posId]);
                    canAccess.next(false);
                },
                error: () => {
                    router.navigate(['/']);
                    canAccess.next(false);
                },
            });
    } else {
        pointOfSaleService.setIsAdminProfile(false);
        canAccess.next(true);
    }

    return canAccess;
};
